import { render } from "./RequestCreateUpdate.vue?vue&type=template&id=6a23a712&scoped=true"
import script from "./RequestCreateUpdate.vue?vue&type=script&lang=js"
export * from "./RequestCreateUpdate.vue?vue&type=script&lang=js"

import "./RequestCreateUpdate.vue?vue&type=style&index=0&id=6a23a712&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a23a712"]])

export default __exports__